import React, { Component } from 'react';
import SchedulleColumnHeader from '../SchedulleColumnHeader';
import EditIcon from '@mui/icons-material/Edit'
import IconButton from '@mui/material/IconButton';
import SchedulleStore from '../SchedulleStore'
import Tooltip from '@mui/material/Tooltip';

export default class CalendarDay extends Component {

    constructor(props) {
        super(props);

        this.state = {
        };

        this.getSum = this.getSum.bind(this);
        this.handleScheduleEdit = this.handleScheduleEdit.bind(this);
    }

    componentDidMount() {
    }

    getSum() {
        var sum = this.props.works.reduce(((accumulator, w) => accumulator + w.minutes), 0);
        var minutes = (sum % 60);
        if (minutes < 10) minutes = '0' + minutes;
        return Math.floor(sum / 60) + "ч " + minutes + 'м';

    }

    divideOnColumns(works) {
        var newWorks = [];
        while (works.length > 0) {
            var topWork = works.splice(0, 1)[0];
            topWork.height = (80 * topWork.minutes / 60);
            //topWork.clipPath = "polygon(0% 0%, 100% 0%, 100% 100%, 100% 100%, 10% 100%, 10% " + height + "px, 0% " + height + "px)";
            var start = new Date(topWork.start);
            topWork.top = 80*(start.getHours() - 8 + start.getMinutes() / 60);
            topWork.end = (topWork.height < 50 ? 50 : topWork.height) + topWork.top;
            topWork.margin = 0;
            topWork.width = 100;
            topWork.widthDivider = 1;

            newWorks.some(w => {
                if (!(topWork.top >= w.end || topWork.end <= w.top)) {
                    //topWork.widthDivider = w.widthDivider;
                    
                    topWork.intersectWork = w;

                    if (w.margin > 0 && (!w.intersectWork || (topWork.top >= w.intersectWork.end || topWork.end <= w.intersectWork.top))) {
                        topWork.margin = 0;
                        topWork.width = 100 - w.margin;
                    }
                    else {
                        w.width = w.width / 2;
                        topWork.margin = w.margin + w.width;
                        topWork.width = 100 - topWork.margin;
                    }

                    return true;
                }

                return false;
            });

            newWorks.push(topWork);
        }

        console.log(newWorks);

        return newWorks;
    }

    handleScheduleEdit = w => () => {
        SchedulleStore.openSchedulleEditDialog(w, this.minutesToTimeStr(w.minutes));
    }

    minutesToTimeStr(minutes) {
        var result = "";
        var hours = Math.floor(minutes / 60);
        if (hours !== 0) {
            result += hours + "ч "
        }

        minutes = minutes % 60;

        if (minutes > 10 || (minutes > 0 && hours === 0)) {
            result += minutes + "м"
        }
        else if (minutes > 0) {
            result += "0" + minutes + "м"
        }

        return result;
    }

    render() {
        //var tasks = this.state.works.map(w => { return { start: new Date(w.start), end: new Date(w.end) } });
        //console.log(tasks);
        return (
            <div className="calendar-day">
                <SchedulleColumnHeader>{this.props.name} {this.getSum()}</SchedulleColumnHeader>
                <div style={{ "position": "relative" }}>
                    <div className="calendar-hour-slot"/>
                    <div className="calendar-hour-slot"/>
                    <div className="calendar-hour-slot"/>
                    <div className="calendar-hour-slot"/>
                    <div className="calendar-hour-slot"/>
                    <div className="calendar-hour-slot"/>
                    <div className="calendar-hour-slot"/>
                    <div className="calendar-hour-slot"/>
                    <div className="calendar-hour-slot"/>
                    <div className="calendar-hour-slot"/>
                    <div className="calendar-hour-slot"/>
                    <div className="calendar-hour-slot"/>
                    <div className="calendar-hour-slot"/>
                    <div className="calendar-hour-slot" />
                    {this.divideOnColumns(this.props.works).map((w, index) => {
                        var height = w.height + "px";
                        var clipPath = "polygon(0% 0%, 100% 0%, 100% 100%, 100% 100%, 10% 100%, 10% " + height + ", 0% " + height + ")";
                        var top = w.top + "px";
                        var width = (100 / w.widthDivider);
                        return (
                            <Tooltip title={w.comment}>
                            <div className="calendar-work-slot"
                                style={{
                                    "background": (index % 2 === 0 ? "rgba(255, 192, 203, 1)" : "rgba(192, 249, 255, 1)"),
                                    "top": top,
                                    "height": height,
                                    "max-height": height,
                                    "clip-path": clipPath,
                                    "width": (w.width - 1) + "%",
                                    "margin-left": w.margin + "%"
                                }}>
                                        <IconButton size="small" onClick={this.handleScheduleEdit(w)}><EditIcon /></IconButton>
                                        <b>{w.workNumber}</b> {w.workCaption}
                                
                                </div></Tooltip>)
                    })}
                </div>
            </div>
        );
    }
}